module.exports = __webpack_public_path__ + "img/menu3-4.37f74cac.jpg";